export const currencies = [
    "UGX", "USD", "CDF"
]


